// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group {
    padding-bottom: 1rem;
}

.btn {
    width: 100%;
    max-width: 450px;
    border-radius: 50px;
    background: #FF9600;
    color: white;
    margin: 0 auto 8px auto;
    cursor: pointer;
    display: block;
    padding: 0.8rem;
    min-height: 45px;
    font-size: 16px;
    font-weight: bold;
}


.modal-body {
    padding: 2rem;
    padding-top: 5rem;
}

.form-title {
    padding-bottom: 1rem;
}

.changecolor {
    cursor: pointer;
    color: #0093A2;
}

input {
    padding: 0.8rem;
    border: 1px solid #B0B0B0;
    border-radius: 12px;
    max-width: 450px;
    width: 100%;
    min-height: 45px;
}

.password-div input {
    padding-right: 35px !important;
}

.labeltext {
    color: black;
    margin-bottom: 0.5rem;
}

.textcolor {
    color: #848484;
    text-align: center;
    font-size: 0.85rem;
    line-height: 1.2;
    word-break: break-word;
    hyphens: auto;
    max-width: 400px;
    margin: 0 auto;
}

.pbc {
    padding-bottom: 3rem;
}

.pbl {
    padding-bottom: 3rem;
    max-width: 400px;
    margin: 0 auto;
    text-align: left;
}

.divider {
    border: 1px solid #B0B0B0;

}

.small-border {
    height: 2px;
    background: #D9D9D9;
    border-left: none;
    border-right: none;
    display: block;
    margin: 0 auto;
    margin-top: 8px;
    padding-top: -33px;
    width: 25%;
}

.btngoogle {
    border: 1px solid #B0B0B0;
    border-radius: 8px;
    padding: 0.8rem;
    background: transparent;
    box-shadow: 0px 10px 15px -5px rgba(0, 0, 0, 0.1), 0px 0px 0px 0px rgba(0, 0, 0, 0.1);
    margin: 0 auto 1rem auto;
    cursor: pointer;
    max-width: 450px;
    width: 100%;
    display: block;
    min-height: 45px;
}

.flex-containerbutton {
    display: flex;
    gap: 40px;
}

.img {
    margin-left: 2rem;
    cursor: pointer;
}

.flex-container {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.flex-container .text-center {
    white-space: nowrap;
    font-size: 0.9rem;
}

.close {
    border: none;
    border-radius: 17px;
    font-size: 14px;
}


.password-div {
    position: relative;
    max-width: 450px;
    margin: 0 auto;
}

.password-div .text-end {
    text-align: right;
    margin-top: 0.5rem;
    width: 100%;
}

.password-div .text-end label {
    display: inline-block;
    text-align: right;
}


.eye-b {
    color: #292929 !important;
    position: absolute !important;
    top: 38% !important;
    right: 20px !important;
    transform: translateY(-50%) !important;
    font-size: 16px !important;
    z-index: 10 !important;
    cursor: pointer !important;
    pointer-events: auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 20px !important;
    height: 20px !important;
    text-decoration: none !important;
    border: none !important;
    background: none !important;
}

.modal-header {
    justify-content: flex-end;
}

.text {
    cursor: pointer;
}

/* Estilos para hacer el modal más redondeado */
.modal-content {
    border-radius: 15px !important;
    width: 100% !important;
    max-width: 600px !important;
    min-height: 500px !important;
    padding: 2rem 3rem !important;
}

/* Centrar los elementos del formulario */
.form-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 450px;
    margin: 0 auto;
}

.form-group input {
    margin: 0;
}

/* Optimización para móvil */
@media screen and (max-width: 768px) {
    .modal-content {
        max-width: 99% !important;
        width: 99% !important;
        min-height: 400px !important;
        padding: 0.8rem 0.8rem !important;
        margin: 0 auto !important;
    }
    
    .modal-body {
        padding: 1rem;
        padding-top: 1.5rem;
    }
    
    input {
        max-width: 100%;
        padding: 0.8rem;
        font-size: 16px;
    }
    
    .btn {
        padding: 1rem;
        font-size: 16px;
    }
    
    .btngoogle {
        padding: 1rem;
        font-size: 16px;
    }
    
    .flex-containerbutton {
        gap: 15px;
    }
    
    .img {
        margin-left: 0.5rem;
    }
    
    .textcolor {
        font-size: 0.9rem;
        line-height: 1.3;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/modal-register/modal-register.component.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,qFAAqF;IACrF,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,sCAAsC;IACtC,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,+BAA+B;IAC/B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,gCAAgC;IAChC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA,+CAA+C;AAC/C;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA,4BAA4B;AAC5B;IACI;QACI,yBAAyB;QACzB,qBAAqB;QACrB,4BAA4B;QAC5B,iCAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;AACJ","sourcesContent":[".form-group {\n    padding-bottom: 1rem;\n}\n\n.btn {\n    width: 100%;\n    max-width: 450px;\n    border-radius: 50px;\n    background: #FF9600;\n    color: white;\n    margin: 0 auto 8px auto;\n    cursor: pointer;\n    display: block;\n    padding: 0.8rem;\n    min-height: 45px;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n\n.modal-body {\n    padding: 2rem;\n    padding-top: 5rem;\n}\n\n.form-title {\n    padding-bottom: 1rem;\n}\n\n.changecolor {\n    cursor: pointer;\n    color: #0093A2;\n}\n\ninput {\n    padding: 0.8rem;\n    border: 1px solid #B0B0B0;\n    border-radius: 12px;\n    max-width: 450px;\n    width: 100%;\n    min-height: 45px;\n}\n\n.password-div input {\n    padding-right: 35px !important;\n}\n\n.labeltext {\n    color: black;\n    margin-bottom: 0.5rem;\n}\n\n.textcolor {\n    color: #848484;\n    text-align: center;\n    font-size: 0.85rem;\n    line-height: 1.2;\n    word-break: break-word;\n    hyphens: auto;\n    max-width: 400px;\n    margin: 0 auto;\n}\n\n.pbc {\n    padding-bottom: 3rem;\n}\n\n.pbl {\n    padding-bottom: 3rem;\n    max-width: 400px;\n    margin: 0 auto;\n    text-align: left;\n}\n\n.divider {\n    border: 1px solid #B0B0B0;\n\n}\n\n.small-border {\n    height: 2px;\n    background: #D9D9D9;\n    border-left: none;\n    border-right: none;\n    display: block;\n    margin: 0 auto;\n    margin-top: 8px;\n    padding-top: -33px;\n    width: 25%;\n}\n\n.btngoogle {\n    border: 1px solid #B0B0B0;\n    border-radius: 8px;\n    padding: 0.8rem;\n    background: transparent;\n    box-shadow: 0px 10px 15px -5px rgba(0, 0, 0, 0.1), 0px 0px 0px 0px rgba(0, 0, 0, 0.1);\n    margin: 0 auto 1rem auto;\n    cursor: pointer;\n    max-width: 450px;\n    width: 100%;\n    display: block;\n    min-height: 45px;\n}\n\n.flex-containerbutton {\n    display: flex;\n    gap: 40px;\n}\n\n.img {\n    margin-left: 2rem;\n    cursor: pointer;\n}\n\n.flex-container {\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.flex-container .text-center {\n    white-space: nowrap;\n    font-size: 0.9rem;\n}\n\n.close {\n    border: none;\n    border-radius: 17px;\n    font-size: 14px;\n}\n\n\n.password-div {\n    position: relative;\n    max-width: 450px;\n    margin: 0 auto;\n}\n\n.password-div .text-end {\n    text-align: right;\n    margin-top: 0.5rem;\n    width: 100%;\n}\n\n.password-div .text-end label {\n    display: inline-block;\n    text-align: right;\n}\n\n\n.eye-b {\n    color: #292929 !important;\n    position: absolute !important;\n    top: 38% !important;\n    right: 20px !important;\n    transform: translateY(-50%) !important;\n    font-size: 16px !important;\n    z-index: 10 !important;\n    cursor: pointer !important;\n    pointer-events: auto !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    width: 20px !important;\n    height: 20px !important;\n    text-decoration: none !important;\n    border: none !important;\n    background: none !important;\n}\n\n.modal-header {\n    justify-content: flex-end;\n}\n\n.text {\n    cursor: pointer;\n}\n\n/* Estilos para hacer el modal más redondeado */\n.modal-content {\n    border-radius: 15px !important;\n    width: 100% !important;\n    max-width: 600px !important;\n    min-height: 500px !important;\n    padding: 2rem 3rem !important;\n}\n\n/* Centrar los elementos del formulario */\n.form-group {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 450px;\n    margin: 0 auto;\n}\n\n.form-group input {\n    margin: 0;\n}\n\n/* Optimización para móvil */\n@media screen and (max-width: 768px) {\n    .modal-content {\n        max-width: 99% !important;\n        width: 99% !important;\n        min-height: 400px !important;\n        padding: 0.8rem 0.8rem !important;\n        margin: 0 auto !important;\n    }\n    \n    .modal-body {\n        padding: 1rem;\n        padding-top: 1.5rem;\n    }\n    \n    input {\n        max-width: 100%;\n        padding: 0.8rem;\n        font-size: 16px;\n    }\n    \n    .btn {\n        padding: 1rem;\n        font-size: 16px;\n    }\n    \n    .btngoogle {\n        padding: 1rem;\n        font-size: 16px;\n    }\n    \n    .flex-containerbutton {\n        gap: 15px;\n    }\n    \n    .img {\n        margin-left: 0.5rem;\n    }\n    \n    .textcolor {\n        font-size: 0.9rem;\n        line-height: 1.3;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
